import { useSelector } from 'react-redux';

import { selectConfirmationFormSchema } from '@cashier/cashier-data-access';
import { ConfirmationFormSchema } from '@cashier/cashier-model';

export const useFormSchema = (): ConfirmationFormSchema | null => {
  return useSelector(selectConfirmationFormSchema);
};
